module.exports = __webpack_public_path__ + "img/footer-logo.3e8918e1.png";